var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12525_29018)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16658 1.66927C4.16658 1.20903 4.53968 0.835938 4.99992 0.835938H14.9999C15.4602 0.835938 15.8333 1.20903 15.8333 1.66927V6.66927H16.6666C17.3296 6.66927 17.9655 6.93266 18.4344 7.4015C18.9032 7.87034 19.1666 8.50623 19.1666 9.16927V13.3359C19.1666 13.999 18.9032 14.6349 18.4344 15.1037C17.9655 15.5725 17.3296 15.8359 16.6666 15.8359H15.8333V18.3359C15.8333 18.7962 15.4602 19.1693 14.9999 19.1693H4.99992C4.53968 19.1693 4.16658 18.7962 4.16658 18.3359V15.8359H3.33325C2.67021 15.8359 2.03433 15.5725 1.56548 15.1037C1.09664 14.6349 0.833252 13.999 0.833252 13.3359V9.16927C0.833252 8.50623 1.09664 7.87034 1.56548 7.4015C2.03433 6.93266 2.67021 6.66927 3.33325 6.66927H4.16658V1.66927ZM5.83325 17.5026H14.1666V12.5026H5.83325V17.5026ZM15.8333 14.1693V11.6693C15.8333 11.209 15.4602 10.8359 14.9999 10.8359H4.99992C4.53968 10.8359 4.16658 11.209 4.16658 11.6693V14.1693H3.33325C3.11224 14.1693 2.90028 14.0815 2.744 13.9252C2.58772 13.7689 2.49992 13.557 2.49992 13.3359V9.16927C2.49992 8.94826 2.58772 8.73629 2.744 8.58001C2.90028 8.42373 3.11224 8.33594 3.33325 8.33594H16.6666C16.8876 8.33594 17.0996 8.42373 17.2558 8.58001C17.4121 8.7363 17.4999 8.94826 17.4999 9.16927V13.3359C17.4999 13.5569 17.4121 13.7689 17.2558 13.9252C17.0996 14.0815 16.8876 14.1693 16.6666 14.1693H15.8333ZM14.1666 2.5026V6.66927H5.83325V2.5026H14.1666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12525_29018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.676481d6ede31a94ef9b028b2eed7ebd.svg";
export { ForwardRef as ReactComponent };